/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { amiriFont } from 'utils/amariFont';
import biteHeader from '../../resources/img/biteHeader.png';

export const searchReport = (title: string, ref: any, query: any, headers: string[], data: any, print: boolean, module: string): any => {
  const arr = data.map((row: any) => {
    if (module === 'bite-score') {
      return (
        [
          row.field,
          row.module,
          row.dataSet,
          row.name,
        ]
      );
    }
    return (
      [
        row.count,
        row.scoreField,
        row.module,
        row.dataset,
        `${Object.keys(row.hitCause)[0]}: ${row.hitCause[Object.keys(row.hitCause)[0]][0]}`
      ]
    );
  });

  const file = html2canvas(ref.current, {
    logging: true,
    useCORS: true,
  }).then((canvas) => {
    const doc = new jsPDF.default('p', 'mm', 'a4');
    const imgData: string = canvas.toDataURL('img/png');
    const imgWidth = 60;
    const imgHeight: number = (canvas.height * imgWidth) / canvas.width;
    const pageHeight = 295;
    let remainingHeight: number = imgHeight;
    let position = 40;

    doc.addImage(imgData, 'PNG', 140, position, imgWidth, imgHeight);
    remainingHeight = remainingHeight - pageHeight;

    while (remainingHeight >= 0) {
      position = remainingHeight - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 140, position * 0.99, imgWidth, imgHeight);
      remainingHeight = remainingHeight - pageHeight;
    }

    while (remainingHeight >= 0) {
      position = remainingHeight - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 140, position * 0.99, imgWidth, imgHeight);
      remainingHeight = remainingHeight - pageHeight;
    }

    doc.addFileToVFS('Amiri-Regular.ttf', amiriFont);
    doc.addFont('Amiri-Regular.ttf', 'Amiri', 'normal');
    // const font = doc.getFont();

    // Header
    doc.setFontSize(24);
    doc.setFont('Amiri', 'bold');
    doc.text('BITE Search Report', 105, 15, { align: 'center' }, null,);

    // Query Deatials
    doc.setLineWidth(125);
    doc.setFontSize(16);
    doc.text('Entity Details:', 10, 35);

    doc.setFontSize(12);
    doc.text(`Primary Search: ${query.primary || query.primary ? `${query.primary}` : ''}`, 20, 45);
    doc.text(`Secondary Search: ${query.secondary ? query.secondary : ''}`, 20, 50);
    doc.text(`Country: ${query.counry ? query.country : ''}`, 20, 75);
    doc.text(`State: ${query.state ? query.state : ''}`, 20, 65);
    doc.text(`City: ${query.city ? query.city : ''}`, 20, 60);
    doc.text(`Postal Code: ${query.postalCode ? query.postalCode : ''}`, 20, 70);

    doc.setFontSize(16);
    doc.text('Commodity Details:', 10, 85);

    doc.setFontSize(12);
    doc.text(`Commodity Name: ${query.commodity_name ? query.commodity_name : ''}`, 20, 95);
    doc.text(`HS Code: ${query.hsCodeSearch ? query.hsCodeSearch : ''}`, 20, 100);

    // Table
    doc.setFontSize(16);
    doc.text('Results Details:', 105, 130, { align: 'center' }, null,);
    (doc as any).autoTable({
      startY: 140,
      head: [ headers ],
      headStyles: { halign: 'center' },
      columnStyles: {
        0: { halign: 'center', cellWidth: 40, font: 'Amiri', fontStyle: 'normal' },
        1: { halign: 'center', cellWidth: 35, font: 'Amiri', fontStyle: 'normal' },
        2: { halign: 'center', cellWidth: 55, font: 'Amiri', fontStyle: 'normal' },
        3: { halign: 'center', cellWidth: 55, font: 'Amiri', fontStyle: 'normal' },
      },
      body: arr,
    });

    let myPDF: any;
    if (print) {
      doc.save(`${title}.pdf`);
    } else {
      myPDF = doc.output('blob');
    }
    return (myPDF);
  });
  return file;
};

export const bulkReport = (title: string, ref: any, headers: string[], data: any, print: boolean): any => {
  const arr = data.map((row: any) => {
    return (
      [
        row.field,
        row.column,
        row.dataSet,
        row.row,
        row.hits,
      ]
    );
  });

  const file = html2canvas(ref.current, {
    logging: true,
    useCORS: true,
  }).then((canvas) => {
    const doc = new jsPDF.default('p', 'mm', 'a4');
    const imgData: string = canvas.toDataURL('img/png');
    const imgWidth = 60;
    const imgHeight: number = (canvas.height * imgWidth) / canvas.width;
    const pageHeight = 295;
    let remainingHeight: number = imgHeight;
    let position = 40;

    doc.addImage(imgData, 'PNG', 140, position, imgWidth, imgHeight);
    remainingHeight = remainingHeight - pageHeight;

    while (remainingHeight >= 0) {
      position = remainingHeight - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 140, position * 0.99, imgWidth, imgHeight);
      remainingHeight = remainingHeight - pageHeight;
    }

    while (remainingHeight >= 0) {
      position = remainingHeight - imgHeight;
      doc.addPage();
      doc.addImage(imgData, 'PNG', 140, position * 0.99, imgWidth, imgHeight);
      remainingHeight = remainingHeight - pageHeight;
    }

    doc.addFileToVFS('Amiri-Regular.ttf', amiriFont);
    doc.addFont('Amiri-Regular.ttf', 'Amiri', 'normal');
    const font = doc.getFont();

    // Header
    doc.setFontSize(24);
    doc.setFont('Amiri', 'bold');
    doc.text('BITE Bulk Report', 105, 15, { align: 'center' }, null,);

    // Query Deatials
    doc.setLineWidth(125);
    doc.setFontSize(16);
    doc.text('Search Details:', 10, 35);

    doc.setFontSize(12);
    doc.text(`Transactions Searched Against: ${data.length}`, 20, 45);

    // Table
    doc.setFontSize(16);
    doc.text('Results Details:', 105, 130, { align: 'center' }, null,);
    (doc as any).autoTable({
      startY: 140,
      head: [ headers ],
      headStyles: { halign: 'center' },
      columnStyles: {
        0: { halign: 'center', cellWidth: 40, font: 'Amiri', fontStyle: 'normal' },
        1: { halign: 'center', cellWidth: 55, font: 'Amiri', fontStyle: 'normal' },
        2: { halign: 'center', cellWidth: 55, font: 'Amiri', fontStyle: 'normal' },
        3: { halign: 'center', cellWidth: 15, font: 'Amiri', fontStyle: 'normal' },
        4: { halign: 'center', cellWidth: 15, font: 'Amiri', fontStyle: 'normal' },
      },
      body: arr,
    });

    let myPDF: any;
    if (print) {
      doc.save(`${title}.pdf`);
    } else {
      myPDF = doc.output('blob');
    }
    return (myPDF);
  });
  return file;
};

export const classificationTicketPDF = async(elementRef: any, name: string) => {
  if (!elementRef.current) {
    return;
  }

  const originalOverflow = elementRef.current.style.overflow;

  // Expand scrollable content before capturing
  elementRef.current.style.overflow = 'visible';

  // Give the browser time to apply changes
  await new Promise((resolve) => setTimeout(resolve, 300));

  const canvas = await html2canvas(elementRef.current, {
    scale: 2,
    useCORS: true, // Helps with external styles
    scrollX: 0,
    scrollY: 0
  });

  // Restore original overflow setting
  elementRef.current.style.overflow = originalOverflow;

  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF.default('p', 'mm', 'a4');

  pdf.addImage(biteHeader, 'PNG', 10, 5, 35, 10);

  pdf.setFontSize(16);
  pdf.text('Classification Ticket', 210 / 2, 25, { align: 'center' });

  const imgWidth = 190;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  pdf.addImage(imgData, 'PNG', 10, 35, imgWidth, imgHeight);

  // Add timestamp
  pdf.setFontSize(10);
  pdf.text(`Generated on: ${new Date().toLocaleString()}`, 10, imgHeight + 45);

  const disclaimerText = 'The 10-digit HTS classification provided is for general informational purposes only and does not constitute legal advice or a binding determination under U.S. customs law. Users must consult a licensed customs broker or legal counsel for official import/export classifications.';

  const pageWidth = 190;

  const wrappedText = pdf.splitTextToSize(disclaimerText, pageWidth - 20);
  let yPos = imgHeight + 55;
  wrappedText.forEach((line: any) => {
    if (yPos > 280) { // Check for page overflow (A4 page height is 297mm)
      pdf.addPage();
      yPos = 20; // Reset Y position on new page
    }
    pdf.text(line, 10, yPos);
    yPos = yPos + 7; // Line spacing
  });

  pdf.save(name);
};
